import React, { useMemo } from 'react';
import cn from 'classnames';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import parseInteger from 'utils/parsers/parseInteger.util';

import CN from './ProgressLine.module.scss';

// eslint-disable-next-line no-nested-ternary
const clamp = (value) => (value < 0 ? 0 : value > 100 ? 100 : value);

const ProgressLine = ({ color: colorFromProps, value: valueFromProps, showNumber }) => {
  const color = fromAnyToTrimmed(colorFromProps);
  const { number, string, raw } = parseInteger({ value: valueFromProps });

  const isValid = Number.isSafeInteger(number);
  const value = isValid ? clamp(number) : 0;
  const isIndeterminate = valueFromProps === true;

  const containerClasses = cn({
    [CN.container]: true,
    [CN.indeterminate]: isIndeterminate,
    [CN[`${color}Color`]]: color,
    [CN.defaultColor]: !color,
  });

  const barClasses = cn({
    [CN.bar]: true,
    [CN.indeterminate]: isIndeterminate,
    [CN[`${color}Color`]]: color,
    [CN.defaultColor]: !color,
  });

  const barStyle = useMemo(() => ({ width: `${value}%` }), [value]);

  return (
    <div
      data-bem="ProgressLine"
      className={CN.component}
      data-value={String(value)}
      data-string={String(string)}
      data-number={String(number)}
      data-raw={String(raw)}
      data-show-number={String(showNumber)}
      data-color={String(color)}
      data-is-valid={String(isValid)}
      data-is-indeterminate={String(isIndeterminate)}
    >
      <div data-bem="ProgressLine__container" className={containerClasses}>
        <div data-bem="ProgressLine__progress" className={barClasses} style={barStyle} />
      </div>

      {fromAnyToBool(showNumber && isValid) && (
        <span data-bem="ProgressLine__label" className={CN.label}>{`${value}%`}</span>
      )}
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default ProgressLine;
